import {
  Authorization,
  AuthorizationPartnerToken,
  PartnerToken,
  Token,
  UserInfo,
} from '@/constants/authorization';
import { Routes } from '@/routes';
import { getSearchValue } from './common-util';
const KeySet = [Authorization, Token, UserInfo];
export const isPartnerPage = () => {
  return (
    window.location.pathname.includes('/partner') || getSearchValue('/partner')
  );
};
const storage = {
  getAuthorization: () => {
    return localStorage.getItem(Authorization);
  },
  getToken: () => {
    return localStorage.getItem(Token);
  },
  getUserInfo: () => {
    return localStorage.getItem(UserInfo);
  },
  getUserInfoObject: () => {
    return JSON.parse(localStorage.getItem('userInfo') || '');
  },
  setAuthorization: (value: string) => {
    localStorage.setItem(Authorization, value);
  },
  setToken: (value: string) => {
    localStorage.setItem(Token, value);
  },
  setUserInfo: (value: string | Record<string, unknown>) => {
    let valueStr = typeof value !== 'string' ? JSON.stringify(value) : value;
    localStorage.setItem(UserInfo, valueStr);
  },
  setItems: (pairs: Record<string, string>) => {
    Object.entries(pairs).forEach(([key, value]) => {
      localStorage.setItem(key, value);
    });
  },
  removeAuthorization: () => {
    localStorage.removeItem(Authorization);
  },
  removeAll: () => {
    if (isPartnerPage()) {
      [PartnerToken, AuthorizationPartnerToken].forEach((x) => {
        localStorage.removeItem(x);
      });
    } else {
      KeySet.forEach((x) => {
        localStorage.removeItem(x);
      });
    }
  },
  setLanguage: (lng: string) => {
    localStorage.setItem('lng', lng);
  },
  getLanguage: (): string => {
    return localStorage.getItem('lng') as string;
  },
  getPartnerToken: () => {
    return localStorage.getItem(PartnerToken) ?? '';
  },
  setPartnerToken: (value: string) => {
    localStorage.setItem(PartnerToken, value);
  },
  removePartnerToken: () => {
    localStorage.removeItem(PartnerToken);
  },
  getPartnerAuthorization: () => {
    return localStorage.getItem(AuthorizationPartnerToken);
  },
  setPartnerAuthorization: (value: string) => {
    localStorage.setItem(AuthorizationPartnerToken, value);
  },
};

export const getAuthorization = () => {
  const auth = getSearchValue('auth');
  const authorization = auth
    ? 'Bearer ' + auth
    : storage.getAuthorization() || '';

  return authorization;
};

export default storage;

// Will not jump to the login page
export function redirectToLogin(e = { pathname: '', search: '' }) {
  if (isPartnerPage()) {
    return (window.location.href = Routes.Partner);
  }
  let vals = '';
  if (e?.pathname && e?.pathname !== '/' && e?.pathname !== '/index') {
    vals = `${window.location.pathname}${window.location.search}`;
  }
  window.location.href = `${location.origin}${vals ? `/login?toPage=${encodeURIComponent(vals)}` : '/index'}`;
}

export function redirectToReview() {
  window.location.href = `${location.origin}/registrationReview`;
}
